import { render, staticRenderFns } from "./MatchData.vue?vue&type=template&id=2e5662d7"
import script from "./MatchData.vue?vue&type=script&lang=js"
export * from "./MatchData.vue?vue&type=script&lang=js"
import style0 from "./MatchData.vue?vue&type=style&index=0&id=2e5662d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports